import api from './api';

export default api;


// WEBPACK FOOTER //
// ./src/api/index.js